import request from '../kernel/request'

export default {
	webClazz: {
		list(params) {
			return request.get('web/clazz', params)
		},
		page(params) {
			return request.get('web/clazz/page', params)
		},
		save(data) {
			return request.post(`web/clazz`, data)
		},
		update(data) {
			return request.put(`web/clazz`, data)
		},
		load(id) {
			return request.get('web/clazz/' + id)
		},
		delete(id) {
			return request.delete('web/clazz/' + id)
		}
	},
	bookWebClazz: {
		list(params) {
			return request.get('book/web', params)
		},
		run(params) {
			return request.put('book/web/run', params)
		},
		page(params) {
			return request.get('book/web/page', params)
		},
		save(data) {
			return request.post(`book/web`, data)
		},
		update(data) {
			return request.put(`book/web`, data)
		},
		load(id) {
			return request.get('book/web/' + id)
		},
		delete(id) {
			return request.delete('book/web/' + id)
		}
	},
	webFollow: {
		list(params) {
			return request.get('web/follow', params)
		},
		page(params) {
			return request.get('web/follow/page', params)
		},
		save(data) {
			return request.post(`web/follow/save`, data)
		},
		update(data) {
			return request.put(`web/follow`, data)
		},
		load(id) {
			return request.get('web/follow/' + id)
		},
		delete(id) {
			return request.delete('web/follow/' + id)
		}
	},
}